import React from 'react';
import Logo from '@/assets/brand/trhine-logo.png';

const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="flex flex-col items-center space-y-6">
        {/* Animated Logo */}
        <div className="relative">
          {/* Pulsing background circle */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="h-32 w-32 rounded-full bg-red-100 animate-ping opacity-75"></div>
          </div>

          {/* Logo container with subtle animation */}
          <div className="relative z-10 animate-bounce-slow">
            <img
              src={Logo}
              alt="TRhine Logo"
              className="h-24 w-24 md:h-32 md:w-32 drop-shadow-lg"
            />
          </div>
        </div>

        {/* Company Name */}
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-bold">
            <span className="text-red-600">TR</span>
            <span className="text-gray-800">hine Services</span>
          </h2>
        </div>

        {/* Loading spinner */}
        <div className="flex space-x-2">
          <div className="h-3 w-3 bg-red-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="h-3 w-3 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="h-3 w-3 bg-red-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>

        {/* Loading text */}
        <p className="text-gray-600 text-sm md:text-base animate-pulse">
          Loading...
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
